import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import type { Database } from '../../lib/database.types';
import { Card, CardHeader, CardTitle } from '@/components/ui/card';

type Customer = Database['public']['Tables']['customers']['Row'];

interface CustomerCardProps {
  customer: Customer;
  onClick: () => void;
}

export const CustomerCard: React.FC<CustomerCardProps> = ({ customer, onClick }) => (
  <Card 
    className="hover:shadow-md transition-shadow cursor-pointer"
    onClick={onClick}
  >
    <CardHeader>
      <CardTitle className="text-lg">
        {customer.first_name} {customer.last_name}
      </CardTitle>
      <div className="space-y-2">
        <div className="flex items-center text-muted-foreground">
          <Mail className="w-4 h-4 mr-2" />
          <span className="text-sm">{customer.email}</span>
        </div>
        <div className="flex items-center text-muted-foreground">
          <Phone className="w-4 h-4 mr-2" />
          <span className="text-sm">{customer.phone}</span>
        </div>
        <div className="flex items-center text-muted-foreground">
          <MapPin className="w-4 h-4 mr-2" />
          <span className="text-sm truncate">
            {customer.address}, {customer.city}, {customer.state}
          </span>
        </div>
      </div>
    </CardHeader>
  </Card>
);